import { makeVar } from '@apollo/client'

import { ThirdPartyBankAccount } from 'types/accounts'
import { GetDebitCardTransactions_getDebitCardTransactionsV2_transactions as DebitCardTransaction } from 'types/gql-types/GetDebitCardTransactions'
import { OptimisticDebitCardTransaction } from 'pages/Transfer/Transfer.types'

export const rvSelectedAccountTransaction =
  makeVar<DebitCardTransaction | null>(null)

export const rvThirdPartyAccounts = makeVar<ThirdPartyBankAccount[]>([])

export const rvOptimisticDebitCardTransactions = makeVar<
  OptimisticDebitCardTransaction[]
>([])

export const rvUpdatedDebitCardTransactions = makeVar<DebitCardTransaction[]>(
  []
)
